import { Card, CardContent } from "@/components/ui/card";

/**
 * One question and answer in a marketing page's FAQ grid. The questions
 * come from the controller, which also emits them as FAQPage JSON-LD.
 *
 * Props:
 *   - question, answer: strings
 *   - as: heading tag for the question, default "h2"
 */
export default function FaqCard({ question, answer, as: Heading = "h2" }) {
  return (
    <Card className="bg-card/70">
      <CardContent className="p-6 md:p-6 space-y-2">
        <Heading className="text-lg font-semibold text-foreground">{question}</Heading>
        <p className="text-sm text-muted-foreground leading-relaxed">{answer}</p>
      </CardContent>
    </Card>
  );
}
